<template>
  <v-container py-0>
    <v-card color="transparent" flat light>
      <v-card-text class="py-0">
        <v-layout row wrap>
          <v-flex xs12 pb-3>
            <h3>{{ $t('models.roleList') }}:</h3>
          </v-flex>
          <v-flex xs12>
            <div class="v-table__overflow">
              <table
                class="v-datatable v-table theme--light"
                style="width: 100%; text-align: left"
              >
                <thead>
                  <tr>
                    <th>{{ $tc('models.role') }}</th>
                    <th>{{ $t('titles.roles.items') }}</th>
                    <th class="text-xs-center">
                      {{ $t('fields.tournaments.confirmed') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(role, index) in roles" :key="index + 200">
                    <td>{{ role.name }}</td>
                    <td>
                      <v-chip
                        v-for="(object, index) in role.objects"
                        :key="index + 220"
                        small
                        color="white"
                      >
                        <v-avatar v-if="object.img">
                          <img :src="object.img" />
                        </v-avatar>
                        {{ object.name }}
                      </v-chip>
                    </td>
                    <td class="text-xs-center">
                      <button-state :state="role.confirm" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'TabRoles',
  props: {
    roles: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
}
</script>
